import { PictureModalWithButton } from '@dora/components';
import * as Preact from 'preact';
import Box from '@mui/material/Box';
import Backdrop from '@mui/material/Backdrop';
import * as AR from '@dora/arctic';

export type Props = {
    activate: () => void;
    generateUSDZ: () => Promise<string>;
    error?: string;
    loading: boolean;
    closeApp: () => void;
    arCompatibility: AR.Compatibility | undefined;
    returnButton?: {
        text: string;
        onClick: () => void;
    };
    arButtonText: string;
    arErrorDialogHeader: string;
    arButtonExplainerText: string;
    arIncompatibleDeviceDialogHeader: string;
};

export const Component = (props: Props) => {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContents: 'center',
                alignItems: 'center',
                height: '100%',
            }}
        >
            <Backdrop open={true}>
                <Box sx={{ maxWidth: { xs: 260, md: 380 }, margin: 'auto' }}>
                    <PictureModalWithButton.Component
                        buttonText={props.arButtonText}
                        image="assets/inspiration-runway.png"
                        onButtonClick={props.activate}
                        error={props.error ? props.arErrorDialogHeader : undefined}
                        onCloseClick={() => props.closeApp()}
                        modalText={
                            props.arCompatibility === AR.Compatibility.Compatible
                                ? props.arButtonExplainerText
                                : props.arIncompatibleDeviceDialogHeader
                        }
                        disabled={props.arCompatibility !== AR.Compatibility.Compatible}
                        loading={props.loading}
                        secondaryButton={props.returnButton ? props.returnButton : undefined}
                    />
                </Box>
            </Backdrop>
        </Box>
    );
};
